import playerPreview from './player-preview';
export default playerPreview;
